import { render, staticRenderFns } from "./generate_articles.vue?vue&type=template&id=6a927460"
import script from "./generate_articles.vue?vue&type=script&lang=js"
export * from "./generate_articles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports